var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconRefresh01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M3.15 2.228A8.45 8.45 0 0 1 8.5.324v.8-.8A7.675 7.675 0 1 1 .825 8v-.8h1.6V8A6.075 6.075 0 1 0 8.5 1.924h-.001A6.85 6.85 0 0 0 4.16 3.467l-.62.506-1.011-1.24z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M3.158.154 4.71.542l-.529 2.116 2.116.529-.388 1.552-3.668-.917z",
  clipRule: "evenodd"
})));
export default SvgIconRefresh01;